import React, { useEffect } from 'react';
import { useActivation } from '@context/MobileOne';
import { useA11y } from '@context/Utils/A11y';
import { LoginPasswordActivation } from './LoginPasswordActivation';
import { LoginPasswordSuccess } from './LoginPasswordSuccess';
import { Meta } from '@core/Meta';
import { keyValueValidation } from '@utils/globalConstant';
import { useTitle } from '@context/Utils/Title';
export function ActivationStep5() {
  // Context
  const { step5SubStep, setShowActivationFooter, setShowActivationHeader } = useActivation();
  const { tA11yTranslate, getGlobalMetaTitles } = useA11y();
  const { announceTitle } = useTitle();
  // META: page titles
  const { globalPageTitle, globalSuccessPageTitle } = getGlobalMetaTitles();
  const activationPasswordPageTitle = tA11yTranslate('ek_global_meta_title_password').content;
  const isTranslationReady = keyValueValidation(
    activationPasswordPageTitle,
    'ek_global_meta_title_password'
  );

  // Determine the page title based on the current substep
  const getPageTitle = () => {
    if (step5SubStep === 1) {
      return `${globalPageTitle} - ${globalSuccessPageTitle}`;
    } else {
      return `${globalPageTitle} - ${activationPasswordPageTitle}`;
    }
  };

  useEffect(() => {
    const pageTitle = `${getPageTitle()}`;
    announceTitle(pageTitle);
  }, [step5SubStep, announceTitle]); // Re-run when substep changes

  // Hooks
  useEffect(() => {
    // Hide footer for below screens
    // 0.1.6.2 - registration step 5 - login-password success
    if (step5SubStep === 1) {
      setShowActivationFooter(false);
    } else {
      setShowActivationFooter(true);
      setShowActivationHeader(true);
    }
  }, [step5SubStep]);

  const renderStep5SubSteps = (subStep) => {
    switch (subStep) {
      case 0:
        return <LoginPasswordActivation />;
      case 1:
        return <LoginPasswordSuccess />;
      default:
        return <LoginPasswordActivation />;
    }
  };

  return (
    <>
      <Meta title={getPageTitle()} key={`meta-key-${step5SubStep}`} />
      {renderStep5SubSteps(step5SubStep)}
    </>
  );
}

export default ActivationStep5;
